const countries = [
  {
    id: 4,
    en: 'Afghanistan',
    sv: 'Afghanistan',
  },
  {
    id: 8,
    en: 'Albania',
    sv: 'Albanien',
  },
  {
    id: 12,
    en: 'Algeria',
    sv: 'Algeriet',
  },
  {
    id: 20,
    en: 'Andorra',
    sv: 'Andorra',
  },
  {
    id: 24,
    en: 'Angola',
    sv: 'Angola',
  },
  {
    id: 28,
    en: 'Antigua and Barbuda',
    sv: 'Antigua och Barbuda',
  },
  {
    id: 32,
    en: 'Argentina',
    sv: 'Argentina',
  },
  {
    id: 51,
    en: 'Armenia',
    sv: 'Armenien',
  },
  {
    id: 36,
    en: 'Australia',
    sv: 'Australien',
  },
  {
    id: 40,
    en: 'Austria',
    sv: 'Österrike',
  },
  {
    id: 31,
    en: 'Azerbaijan',
    sv: 'Azerbajdzjan',
  },
  {
    id: 44,
    en: 'Bahamas',
    sv: 'Bahamas',
  },
  {
    id: 48,
    en: 'Bahrain',
    sv: 'Bahrain',
  },
  {
    id: 50,
    en: 'Bangladesh',
    sv: 'Bangladesh',
  },
  {
    id: 52,
    en: 'Barbados',
    sv: 'Barbados',
  },
  {
    id: 112,
    en: 'Belarus',
    sv: 'Belarus',
  },
  {
    id: 56,
    en: 'Belgium',
    sv: 'Belgien',
  },
  {
    id: 84,
    en: 'Belize',
    sv: 'Belize',
  },
  {
    id: 204,
    en: 'Benin',
    sv: 'Benin',
  },
  {
    id: 64,
    en: 'Bhutan',
    sv: 'Bhutan',
  },
  {
    id: 68,
    en: 'Bolivia (Plurinational State of)',
    sv: 'Bolivia',
  },
  {
    id: 70,
    en: 'Bosnia and Herzegovina',
    sv: 'Bosnien och Hercegovina',
  },
  {
    id: 72,
    en: 'Botswana',
    sv: 'Botswana',
  },
  {
    id: 76,
    en: 'Brazil',
    sv: 'Brasilien',
  },
  {
    id: 96,
    en: 'Brunei Darussalam',
    sv: 'Brunei',
  },
  {
    id: 100,
    en: 'Bulgaria',
    sv: 'Bulgarien',
  },
  {
    id: 854,
    en: 'Burkina Faso',
    sv: 'Burkina Faso',
  },
  {
    id: 108,
    en: 'Burundi',
    sv: 'Burundi',
  },
  {
    id: 116,
    en: 'Cambodia',
    sv: 'Kambodja',
  },
  {
    id: 120,
    en: 'Cameroon',
    sv: 'Kamerun',
  },
  {
    id: 124,
    en: 'Canada',
    sv: 'Kanada',
  },
  {
    id: 132,
    en: 'Cabo Verde',
    sv: 'Kap Verde',
  },
  {
    id: 140,
    en: 'Central African Republic',
    sv: 'Centralafrikanska republiken',
  },
  {
    id: 148,
    en: 'Chad',
    sv: 'Tchad',
  },
  {
    id: 152,
    en: 'Chile',
    sv: 'Chile',
  },
  {
    id: 156,
    en: 'China',
    sv: 'Kina',
  },
  {
    id: 170,
    en: 'Colombia',
    sv: 'Colombia',
  },
  {
    id: 174,
    en: 'Comoros',
    sv: 'Komorerna',
  },
  {
    id: 178,
    en: 'Congo',
    sv: 'Kongo-Brazzaville',
  },
  {
    id: 180,
    en: 'Congo, Democratic Republic of the',
    sv: 'Kongo-Kinshasa',
  },
  {
    id: 188,
    en: 'Costa Rica',
    sv: 'Costa Rica',
  },
  {
    id: 384,
    en: "Côte d'Ivoire",
    sv: 'Elfenbenskusten',
  },
  {
    id: 191,
    en: 'Croatia',
    sv: 'Kroatien',
  },
  {
    id: 192,
    en: 'Cuba',
    sv: 'Kuba',
  },
  {
    id: 196,
    en: 'Cyprus',
    sv: 'Cypern',
  },
  {
    id: 203,
    en: 'Czechia',
    sv: 'Tjeckien',
  },
  {
    id: 208,
    en: 'Denmark',
    sv: 'Danmark',
  },
  {
    id: 262,
    en: 'Djibouti',
    sv: 'Djibouti',
  },
  {
    id: 212,
    en: 'Dominica',
    sv: 'Dominica',
  },
  {
    id: 214,
    en: 'Dominican Republic',
    sv: 'Dominikanska republiken',
  },
  {
    id: 218,
    en: 'Ecuador',
    sv: 'Ecuador',
  },
  {
    id: 818,
    en: 'Egypt',
    sv: 'Egypten',
  },
  {
    id: 222,
    en: 'El Salvador',
    sv: 'El Salvador',
  },
  {
    id: 226,
    en: 'Equatorial Guinea',
    sv: 'Ekvatorialguinea',
  },
  {
    id: 232,
    en: 'Eritrea',
    sv: 'Eritrea',
  },
  {
    id: 233,
    en: 'Estonia',
    sv: 'Estland',
  },
  {
    id: 231,
    en: 'Ethiopia',
    sv: 'Etiopien',
  },
  {
    id: 242,
    en: 'Fiji',
    sv: 'Fiji',
  },
  {
    id: 246,
    en: 'Finland',
    sv: 'Finland',
  },
  {
    id: 250,
    en: 'France',
    sv: 'Frankrike',
  },
  {
    id: 266,
    en: 'Gabon',
    sv: 'Gabon',
  },
  {
    id: 270,
    en: 'Gambia',
    sv: 'Gambia',
  },
  {
    id: 268,
    en: 'Georgia',
    sv: 'Georgien',
  },
  {
    id: 276,
    en: 'Germany',
    sv: 'Tyskland',
  },
  {
    id: 288,
    en: 'Ghana',
    sv: 'Ghana',
  },
  {
    id: 300,
    en: 'Greece',
    sv: 'Grekland',
  },
  {
    id: 308,
    en: 'Grenada',
    sv: 'Grenada',
  },
  {
    id: 320,
    en: 'Guatemala',
    sv: 'Guatemala',
  },
  {
    id: 324,
    en: 'Guinea',
    sv: 'Guinea',
  },
  {
    id: 624,
    en: 'Guinea-Bissau',
    sv: 'Guinea-Bissau',
  },
  {
    id: 328,
    en: 'Guyana',
    sv: 'Guyana',
  },
  {
    id: 332,
    en: 'Haiti',
    sv: 'Haiti',
  },
  {
    id: 340,
    en: 'Honduras',
    sv: 'Honduras',
  },
  {
    id: 348,
    en: 'Hungary',
    sv: 'Ungern',
  },
  {
    id: 352,
    en: 'Iceland',
    sv: 'Island',
  },
  {
    id: 356,
    en: 'India',
    sv: 'Indien',
  },
  {
    id: 360,
    en: 'Indonesia',
    sv: 'Indonesien',
  },
  {
    id: 364,
    en: 'Iran (Islamic Republic of)',
    sv: 'Iran',
  },
  {
    id: 368,
    en: 'Iraq',
    sv: 'Irak',
  },
  {
    id: 372,
    en: 'Ireland',
    sv: 'Irland',
  },
  {
    id: 376,
    en: 'Israel',
    sv: 'Israel',
  },
  {
    id: 380,
    en: 'Italy',
    sv: 'Italien',
  },
  {
    id: 388,
    en: 'Jamaica',
    sv: 'Jamaica',
  },
  {
    id: 392,
    en: 'Japan',
    sv: 'Japan',
  },
  {
    id: 400,
    en: 'Jordan',
    sv: 'Jordanien',
  },
  {
    id: 398,
    en: 'Kazakhstan',
    sv: 'Kazakstan',
  },
  {
    id: 404,
    en: 'Kenya',
    sv: 'Kenya',
  },
  {
    id: 296,
    en: 'Kiribati',
    sv: 'Kiribati',
  },
  {
    id: 408,
    en: "Korea (Democratic People's Republic of)",
    sv: 'Nordkorea',
  },
  {
    id: 410,
    en: 'Korea, Republic of',
    sv: 'Sydkorea',
  },
  {
    id: 414,
    en: 'Kuwait',
    sv: 'Kuwait',
  },
  {
    id: 417,
    en: 'Kyrgyzstan',
    sv: 'Kirgizistan',
  },
  {
    id: 418,
    en: "Lao People's Democratic Republic",
    sv: 'Laos',
  },
  {
    id: 428,
    en: 'Latvia',
    sv: 'Lettland',
  },
  {
    id: 422,
    en: 'Lebanon',
    sv: 'Libanon',
  },
  {
    id: 426,
    en: 'Lesotho',
    sv: 'Lesotho',
  },
  {
    id: 430,
    en: 'Liberia',
    sv: 'Liberia',
  },
  {
    id: 434,
    en: 'Libya',
    sv: 'Libyen',
  },
  {
    id: 438,
    en: 'Liechtenstein',
    sv: 'Liechtenstein',
  },
  {
    id: 440,
    en: 'Lithuania',
    sv: 'Litauen',
  },
  {
    id: 442,
    en: 'Luxembourg',
    sv: 'Luxemburg',
  },
  {
    id: 807,
    en: 'North Macedonia',
    sv: 'Nordmakedonien',
  },
  {
    id: 450,
    en: 'Madagascar',
    sv: 'Madagaskar',
  },
  {
    id: 454,
    en: 'Malawi',
    sv: 'Malawi',
  },
  {
    id: 458,
    en: 'Malaysia',
    sv: 'Malaysia',
  },
  {
    id: 462,
    en: 'Maldives',
    sv: 'Maldiverna',
  },
  {
    id: 466,
    en: 'Mali',
    sv: 'Mali',
  },
  {
    id: 470,
    en: 'Malta',
    sv: 'Malta',
  },
  {
    id: 584,
    en: 'Marshall Islands',
    sv: 'Marshallöarna',
  },
  {
    id: 478,
    en: 'Mauritania',
    sv: 'Mauretanien',
  },
  {
    id: 480,
    en: 'Mauritius',
    sv: 'Mauritius',
  },
  {
    id: 484,
    en: 'Mexico',
    sv: 'Mexiko',
  },
  {
    id: 583,
    en: 'Micronesia (Federated States of)',
    sv: 'Mikronesiska federationen',
  },
  {
    id: 504,
    en: 'Morocco',
    sv: 'Marocko',
  },
  {
    id: 498,
    en: 'Moldova, Republic of',
    sv: 'Moldavien',
  },
  {
    id: 492,
    en: 'Monaco',
    sv: 'Monaco',
  },
  {
    id: 496,
    en: 'Mongolia',
    sv: 'Mongoliet',
  },
  {
    id: 499,
    en: 'Montenegro',
    sv: 'Montenegro',
  },
  {
    id: 508,
    en: 'Mozambique',
    sv: 'Moçambique',
  },
  {
    id: 104,
    en: 'Myanmar',
    sv: 'Myanmar',
  },
  {
    id: 516,
    en: 'Namibia',
    sv: 'Namibia',
  },
  {
    id: 520,
    en: 'Nauru',
    sv: 'Nauru',
  },
  {
    id: 524,
    en: 'Nepal',
    sv: 'Nepal',
  },
  {
    id: 528,
    en: 'Netherlands',
    sv: 'Nederländerna',
  },
  {
    id: 554,
    en: 'New Zealand',
    sv: 'Nya Zeeland',
  },
  {
    id: 558,
    en: 'Nicaragua',
    sv: 'Nicaragua',
  },
  {
    id: 562,
    en: 'Niger',
    sv: 'Niger',
  },
  {
    id: 566,
    en: 'Nigeria',
    sv: 'Nigeria',
  },
  {
    id: 578,
    en: 'Norway',
    sv: 'Norge',
  },
  {
    id: 512,
    en: 'Oman',
    sv: 'Oman',
  },
  {
    id: 586,
    en: 'Pakistan',
    sv: 'Pakistan',
  },
  {
    id: 585,
    en: 'Palau',
    sv: 'Palau',
  },
  {
    id: 591,
    en: 'Panama',
    sv: 'Panama',
  },
  {
    id: 598,
    en: 'Papua New Guinea',
    sv: 'Papua Nya Guinea',
  },
  {
    id: 600,
    en: 'Paraguay',
    sv: 'Paraguay',
  },
  {
    id: 604,
    en: 'Peru',
    sv: 'Peru',
  },
  {
    id: 608,
    en: 'Philippines',
    sv: 'Filippinerna',
  },
  {
    id: 616,
    en: 'Poland',
    sv: 'Polen',
  },
  {
    id: 620,
    en: 'Portugal',
    sv: 'Portugal',
  },
  {
    id: 634,
    en: 'Qatar',
    sv: 'Qatar',
  },
  {
    id: 642,
    en: 'Romania',
    sv: 'Rumänien',
  },
  {
    id: 643,
    en: 'Russian Federation',
    sv: 'Ryssland',
  },
  {
    id: 646,
    en: 'Rwanda',
    sv: 'Rwanda',
  },
  {
    id: 659,
    en: 'Saint Kitts and Nevis',
    sv: 'Saint Kitts och Nevis',
  },
  {
    id: 662,
    en: 'Saint Lucia',
    sv: 'Saint Lucia',
  },
  {
    id: 670,
    en: 'Saint Vincent and the Grenadines',
    sv: 'Saint Vincent och Grenadinerna',
  },
  {
    id: 882,
    en: 'Samoa',
    sv: 'Samoa',
  },
  {
    id: 674,
    en: 'San Marino',
    sv: 'San Marino',
  },
  {
    id: 678,
    en: 'Sao Tome and Principe',
    sv: 'São Tomé och Príncipe',
  },
  {
    id: 682,
    en: 'Saudi Arabia',
    sv: 'Saudiarabien',
  },
  {
    id: 686,
    en: 'Senegal',
    sv: 'Senegal',
  },
  {
    id: 688,
    en: 'Serbia',
    sv: 'Serbien',
  },
  {
    id: 690,
    en: 'Seychelles',
    sv: 'Seychellerna',
  },
  {
    id: 694,
    en: 'Sierra Leone',
    sv: 'Sierra Leone',
  },
  {
    id: 702,
    en: 'Singapore',
    sv: 'Singapore',
  },
  {
    id: 703,
    en: 'Slovakia',
    sv: 'Slovakien',
  },
  {
    id: 705,
    en: 'Slovenia',
    sv: 'Slovenien',
  },
  {
    id: 90,
    en: 'Solomon Islands',
    sv: 'Salomonöarna',
  },
  {
    id: 706,
    en: 'Somalia',
    sv: 'Somalia',
  },
  {
    id: 710,
    en: 'South Africa',
    sv: 'Sydafrika',
  },
  {
    id: 728,
    en: 'South Sudan',
    sv: 'Sydsudan',
  },
  {
    id: 724,
    en: 'Spain',
    sv: 'Spanien',
  },
  {
    id: 144,
    en: 'Sri Lanka',
    sv: 'Sri Lanka',
  },
  {
    id: 729,
    en: 'Sudan',
    sv: 'Sudan',
  },
  {
    id: 740,
    en: 'Suriname',
    sv: 'Surinam',
  },
  {
    id: 748,
    en: 'Eswatini',
    sv: 'Swaziland',
  },
  {
    id: 752,
    en: 'Sweden',
    sv: 'Sverige',
  },
  {
    id: 756,
    en: 'Switzerland',
    sv: 'Schweiz',
  },
  {
    id: 760,
    en: 'Syrian Arab Republic',
    sv: 'Syrien',
  },
  {
    id: 762,
    en: 'Tajikistan',
    sv: 'Tadzjikistan',
  },
  {
    id: 834,
    en: 'Tanzania, United Republic of',
    sv: 'Tanzania',
  },
  {
    id: 764,
    en: 'Thailand',
    sv: 'Thailand',
  },
  {
    id: 626,
    en: 'Timor-Leste',
    sv: 'Östtimor',
  },
  {
    id: 768,
    en: 'Togo',
    sv: 'Togo',
  },
  {
    id: 776,
    en: 'Tonga',
    sv: 'Tonga',
  },
  {
    id: 780,
    en: 'Trinidad and Tobago',
    sv: 'Trinidad och Tobago',
  },
  {
    id: 788,
    en: 'Tunisia',
    sv: 'Tunisien',
  },
  {
    id: 792,
    en: 'Turkey',
    sv: 'Turkiet',
  },
  {
    id: 795,
    en: 'Turkmenistan',
    sv: 'Turkmenistan',
  },
  {
    id: 798,
    en: 'Tuvalu',
    sv: 'Tuvalu',
  },
  {
    id: 800,
    en: 'Uganda',
    sv: 'Uganda',
  },
  {
    id: 804,
    en: 'Ukraine',
    sv: 'Ukraina',
  },
  {
    id: 784,
    en: 'United Arab Emirates',
    sv: 'Förenade Arabemiraten',
  },
  {
    id: 826,
    en: 'United Kingdom of Great Britain and Northern Ireland',
    sv: 'Storbritannien',
  },
  {
    id: 840,
    en: 'United States of America',
    sv: 'USA',
  },
  {
    id: 858,
    en: 'Uruguay',
    sv: 'Uruguay',
  },
  {
    id: 860,
    en: 'Uzbekistan',
    sv: 'Uzbekistan',
  },
  {
    id: 548,
    en: 'Vanuatu',
    sv: 'Vanuatu',
  },
  {
    id: 862,
    en: 'Venezuela (Bolivarian Republic of)',
    sv: 'Venezuela',
  },
  {
    id: 704,
    en: 'Viet Nam',
    sv: 'Vietnam',
  },
  {
    id: 887,
    en: 'Yemen',
    sv: 'Jemen',
  },
  {
    id: 894,
    en: 'Zambia',
    sv: 'Zambia',
  },
  {
    id: 716,
    en: 'Zimbabwe',
    sv: 'Zimbabwe',
  },
  {
    id: 983, // user-assigned (XK); not official ISO 3166-1
    en: 'Kosovo',
    sv: 'Kosovo',
  },
];

export const translateCountry = (enCountry) => {
  const foundCountry = countries.find(
    (country) => country.en.toLowerCase() === enCountry.toLowerCase()
  );
  return foundCountry ? foundCountry.sv : enCountry;
};

export default countries;
